import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PORTRAIT = "https://images.unsplash.com/photo-1743200466143-3fc6b9a0f0d9?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

const caps = [
  ["Conversation", "Modèle de langage OpenAI de dernière génération, réponses en temps réel."],
  ["Écoute", "Reconnaissance vocale Whisper, optimisée pour le français."],
  ["Voix", "Synthèse vocale OpenAI naturelle, plusieurs timbres au choix."],
  ["Images", "Génération d'images Gemini Nano Banana, styles variés."],
  ["Galerie", "Toutes vos créations sauvegardées, téléchargeables à tout moment."],
  ["Notifications", "Alertes du navigateur quand une création est prête."],
];

export default function About() {
  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16">
      <section className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7 fade-up">
          <span className="label-mono text-[var(--accent)]">À propos</span>
          <h1 data-testid="about-title" className="font-serif text-5xl sm:text-6xl mt-5 leading-tight">Une présence numérique, <em>humaine</em> et créative.</h1>
          <p className="text-lg text-[var(--text-secondary)] mt-8 max-w-2xl leading-relaxed">Sem.IA est née d'une idée simple : la technologie devrait nous parler comme une amie. Elle réunit la conversation, la voix et la création d'images dans une interface douce et élégante, pensée pour le quotidien.</p>
          <p className="text-lg text-[var(--text-secondary)] mt-4 max-w-2xl leading-relaxed">Que vous ayez besoin d'une idée, d'un conseil, d'une histoire ou d'une illustration, Sem.IA est là — à l'écrit comme à l'oral.</p>
        </div>
        <div className="lg:col-span-4 lg:col-start-9 rounded-[32px] overflow-hidden aspect-[3/4]">
          <img src={PORTRAIT} alt="Portrait éditorial" className="w-full h-full object-cover" />
        </div>
      </section>

      <section className="py-24">
        <h2 className="font-serif text-4xl mb-10">Ses capacités</h2>
        <div className="border-t border-[var(--border)]">
          {caps.map(([t, d], i) => (
            <div key={t} data-testid={`about-capability-${i}`} className="grid md:grid-cols-12 gap-4 py-7 border-b border-[var(--border)] group">
              <span className="md:col-span-1 label-mono text-[var(--text-muted)] pt-2">0{i + 1}</span>
              <h3 className="md:col-span-4 text-2xl font-medium group-hover:text-[var(--accent)] transition-colors">{t}</h3>
              <p className="md:col-span-7 text-[var(--text-secondary)] text-lg">{d}</p>
            </div>
          ))}
        </div>
        <Link to="/studio" data-testid="about-cta" className="btn-primary mt-12">Essayer Sem.IA <ArrowRight size={16} /></Link>
      </section>
    </div>
  );
}
